import { HomeController } from "../../home/HomeController.js";
import { PolizaController } from "../../poliza/PolizaController.js";
import { AuthController } from "../../auth/AuthController.js";
import { AuthService } from "../services/AuthService.js";

// Para agregar una nueva seccion:
// 1. Crear src/<seccion>/<Seccion>Controller.js con un metodo render()
// 2. Importarlo aqui
// 3. Agregar la ruta en el constructor

export class Router {
  constructor(isAuthenticated = false) {
    this.isAuthenticated = isAuthenticated;
    this.routes = {
      "": (params) => this.requireAuth(() => HomeController.render(params)),
      home: (params) => this.requireAuth(() => HomeController.render(params)),
      poliza: (params) => this.requireAuth(() => PolizaController.render(params)),
      login: () => this.soloAnonimo(() => AuthController.renderLogin()),
      registro: () => this.soloAnonimo(() => AuthController.renderRegistro()),
      recuperar: () => this.soloAnonimo(() => AuthController.renderRecuperar()),
      // Sin guard a proposito: la credencial es el token del enlace del mail, no la sesion. Con
      // soloAnonimo, quien tuviera sesion abierta en el celular iria a parar al home y perderia
      // el token de la URL — justamente el caso de quien pidio la clave nueva por no recordarla.
      restablecer: (params) => AuthController.renderRestablecer(params),
    };
  }

  init() {
    window.addEventListener("hashchange", () => this.handleRoute());
    this.handleRoute();
  }

  handleRoute() {
    const hash = window.location.hash.slice(1) || "";
    const [path, queryString] = hash.split("?");
    const route = this.routes[path] || this.routes[""];
    const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams();
    window.scrollTo(0, 0);
    route(params);
  }

  /** El estado de sesión se relee de AuthService: tras un login no hay que recrear el Router. */
  requireAuth(callback) {
    this.isAuthenticated = !!AuthService.getToken();
    if (this.isAuthenticated) return callback();
    window.location.hash = "login";
  }

  /** Un usuario logueado no debería ver login/registro: se lo manda al home. */
  soloAnonimo(callback) {
    this.isAuthenticated = !!AuthService.getToken();
    if (this.isAuthenticated) {
      window.location.hash = "home";
      return;
    }
    return callback();
  }

  navigate(path) {
    window.location.hash = path;
  }
}
